
<div *ngIf="control.invalid && (control.touched || control.dirty)" class="text-right text-danger f-12">

  <span [hidden]="!control.errors?.required">
    Campo obrigatório. <br>
  </span>

  <span [hidden]="!control.errors?.email">
    Email inválido. <br>
  </span>
  <span [hidden]="!control.errors?.cpf">
    Cpf inválido. <br>
  </span>
  <span [hidden]="!control.errors?.cnpj">
    Cnpj inválido. <br>
  </span>
  <span [hidden]="!control.errors?.minlength">
    Mínimo de {{control.errors.minlength?.requiredLength}} caracteres requeridos,
    {{control.errors.minlength?.actualLength}} informados. <br>
  </span>
  <span [hidden]="!control.errors?.maxlength">
    Máximo de {{control.errors.maxlength?.requiredLength}} caracteres, {{control.errors.maxlength?.actualLength}}
    informados. <br>
  </span>
  <span [hidden]="!control.errors?.min">
      Valor mínimo {{control.errors.min?.min}} <br>
    </span>
    <span [hidden]="!control.errors?.max">
      Valor máximo {{control.errors.max?.max}} <br>
    </span>
  <span [hidden]="!control.errors?.password">
    Senha incorreta. <br>
  </span>
  <span [hidden]="!control.errors?.equal">
    Dados não conferem. <br>
  </span>

  <span [hidden]="!control.errors?.decimal">
    Número inválido. <br>
  </span>

  <span [hidden]="!control.errors?.decimalMin">
    Valor mínimo {{control.errors.decimalMin?.min | number:'2.2-2'}} <br>
  </span>

  <span [hidden]="!control.errors?.msg">
    {{control.errors?.msg}} <br>
  </span>

  <span [hidden]="!control.errors?.semNumero">
    Selecione ao menos um número.<br>
  </span>
  
  <span [hidden]="!control.errors?.semMaiuscula">
    Selecione ao menos uma letra maiúscula.<br>
  </span>

  <span [hidden]="!control.errors?.semMinuscula">
    Selecione ao menos uma letra minúscula.<br>
  </span>

  <span [hidden]="!control.errors?.semCaracterEspecial">
    Selecione ao menos um caracter especial.<br>
  </span>

</div>
